import { Markierung } from '@/domain/mitarbeiter/features/rotationsplan/entities/Markierung';

export class Beruf {
  constructor({
    markierung,
    name,
    abkuerzung,
  }: {
    markierung: Markierung;
    name: string;
    abkuerzung: string;
  }) {
    this.markierung = markierung;
    this.name = name;
    this.abkuerzung = abkuerzung;
  }

  markierung: Markierung;
  name: string;
  abkuerzung: string;
}
